import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { setPaymobLinkDatas } from '../../store/reducers/replica';
const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#f3f4f6',
        padding:'0 3rem'
    },
    card: {
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: '0.5rem',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        width:'25rem'
    },
    icon: {
        color: '#ffb700',
    },
    title: {
        fontSize: '1.5rem',
        fontWeight: 'bold',
        color: '#1f2937',
        marginBottom: '0.5rem',
    },
    message: {
        color: '#4b5563',
    },
};

const PaymobProcess = () => {
    // const dispatch = useDispatch();

    // useEffect(() => {
    //     // Get current URL
    //     const currentUrl = window.location.href;
    //     console.log("🚀 ~ useEffect ~ currentUrl:", currentUrl)
    //     dispatch(setPaymobLinkDatas(currentUrl))
    //     // Store in local storage
    //     localStorage.setItem('currentUrl', currentUrl);
    //   }, []);

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <div style={styles.icon}><i class="fa-regular fa-clock fa-3x"></i></div>
                <h2 style={styles.title}>Payment Processed</h2>
                <p style={styles.message}>Your transaction has been processed. Please click the 'Finish' button to proceed.</p>
            </div>
        </div>
    )
}

export default PaymobProcess;